import { render, staticRenderFns } from "./ToOrder.vue?vue&type=template&id=184fc70c&"
import script from "./ToOrder.vue?vue&type=script&lang=js&"
export * from "./ToOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports